var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mid"},_vm._l((_vm.alphabet),function(letter){return _c('span',{key:letter,class:{ 'active': _vm.selectedLetter === letter },on:{"click":function($event){return _vm.selectLetter(letter)}}},[_vm._v(" "+_vm._s(letter)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }